
import { defineComponent, getCurrentInstance, ref, watch } from "vue";

export default defineComponent({
  name: "InputNumber",
  props: {
    value: { type: Number },
    disabled: { type: Boolean },
    suffix: { type: String },
    minValue: { type: Number },
    maxValue: { type: Number },
    defValue: { type: Number },
  },
  setup(props, context) {
    const instance = getCurrentInstance();
    const innerValue = ref(props.value);
    watch(
      () => props.value,
      (newVal) => {
        innerValue.value = newVal ?? props.minValue ?? 0;
      }
    );

    const tryUpdate = (e: Event) => {
      const value = (e.target as HTMLInputElement).value;
      const length = value.length;
      const maxValue = props.maxValue ?? Number.MAX_VALUE;
      const maxLength = String(maxValue).length;
      const num = Number.parseInt(value);

      if (Number.isNaN(num)) {
        innerValue.value = undefined;
        return;
      }

      if (length <= maxLength) {
        innerValue.value = num;
        if (isInRange(num)) {
          context.emit("update:value", num);
        }
      } else {
        instance?.proxy?.$forceUpdate();
      }
    };
    const commit = () => {
      // 空欄だったらデフォルト値を設定
      if (
        !innerValue.value ||
        Number.isNaN(innerValue.value) ||
        !isInRange(innerValue.value)
      ) {
        innerValue.value = props.defValue ?? props.minValue ?? 0;
      }

      const rounded = rounding(innerValue.value);
      innerValue.value = rounded;
      context.emit("update:value", rounded);
    };

    // 指定された範囲に値が収まっているか
    const isInRange = (v: number) => {
      if (props.minValue !== undefined && v < props.minValue) {
        return false;
      }
      if (props.maxValue !== undefined && props.maxValue < v) {
        return false;
      }
      return true;
    };

    // 値が指定された範囲外だった場合の丸め処理
    const rounding = (v: number) => {
      if (props.minValue !== undefined && v < props.minValue) {
        v = props.minValue;
      }
      if (props.maxValue !== undefined && props.maxValue < v) {
        v = props.maxValue;
      }
      return v;
    };
    return {
      innerValue,
      commit,
      tryUpdate,
      context,
    };
  },
});
